import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useGetUploadList } from '../api/main'
import { Button_Main } from '../components/Button'
import { Dialog } from '../components/Dialog'
import Pagenation from '../components/Pagenation'
import SearchForm, { DefaultParamKeys } from '../components/Search'
import Table from '../components/Table'
import { Main } from '../styles/layout'
import { Table_Info } from '../styles/table'

const Upload = () => {
  const location = useLocation()
  const { data, isLoading, isError } = useGetUploadList(location.search)
  // 여기 모가있을건데...
//테이블에 색상주기 모달키주기 , 테이블 키값주기 3개로 받아야겟다...
  return (
    <Main>
      <h1>업로드 이력</h1>
      <SearchForm searchList={searchList}/>
      <Table_Info>
        Total Count: {data?.total}
      </Table_Info>
      <Table headers={headers} data={data?.data} isLoading={isLoading} isError={isError} rowKey={'macAddress'} modalKey={'deviceId'} rowBtn={'push'} onClick={()=>{}}/>
      <Pagenation totalPage={data?.totalPage} isLoading={isLoading}/>
    </Main>
  )
}

export default Upload

const headers = [
  { value: 'partName', label: '소속' },
  { value: 'groupName', label: '그룹' },
  { value: 'macAddress', label: 'MAC' },
  { value: 'driveNumber', label: '차량번호' },
  { value: 'deviceAlias', label: '별칭' },
  { value: 'uploadedDate', label: '업로드 일자' }
]

const searchList:DefaultParamKeys[] = [
  'partName',
  'groupName',
  'macAddress',
  'driveNumber'
]